var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"test-container-fontautoscale"},[_c('div',{ref:"resizeContainer",staticClass:"resizable-container-fontautoscale elevation-8",style:(_vm.textContainerStyle)},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),_c('v-text-field',{style:({
                        position: 'absolute',
                        bottom: '8px',
                        width: '40%',
                        'background-color': 'white'
                  }),attrs:{"hide-details":"","label":"Text","outlined":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }